/** Active buyer cart route (MAD checkout UX). */
export const ACTIVE_CART_PATH = '/cart';

/** Legacy route — redirect to {@link ACTIVE_CART_PATH}. */
export const LEGACY_PUBLIC_CART_PATH = '/public-cart';

export function resolvePublicCartRedirect(pathname: string): string | null {
  if (pathname === LEGACY_PUBLIC_CART_PATH || pathname === `${LEGACY_PUBLIC_CART_PATH}/`) {
    return ACTIVE_CART_PATH;
  }
  return null;
}
